interface ResumeCardProps {
  icon: React.ReactNode;
  label: React.ReactNode;
  value: string | number;
  valueColor?: string;
  isPrice?: boolean;
  isLoading?: boolean;
  subtitle?: string;
}

export function ResumeCard({
  icon,
  label,
  value,
  valueColor = 'text-neutral-500',
  isPrice = false,
  isLoading = false,
  subtitle,
}: ResumeCardProps) {
  if (isLoading) {
    return (
      <div className="w-full h-24 p-4 rounded-lg bg-primary-200 animate-pulse">
        <div className="flex items-center gap-4">
          <div className="size-16 bg-neutral-300 rounded-full" />
          <div className="flex flex-col gap-2">
            <div className="h-4 w-32 bg-neutral-300 rounded" />
            <div className="h-6 w-16 bg-neutral-300 rounded" />
          </div>
        </div>
      </div>
    );
  }

  function renderValue() {
    if (!isPrice) {
      return <p className={`text-font24 font-bold ${valueColor}`}>{value}</p>;
    }

    return (
      <p className={`flex items-center font-bold ${valueColor} gap-1`}>
        <span className="text-font16">R$</span>
        <span className="text-font24">{value}</span>
      </p>
    );
  }

  return (
    <div className="flex items-center flex-grow h-24 gap-4 p-4 rounded-lg bg-primary-200 w-full">
      <div className="flex justify-center items-center size-16 rounded-full bg-neutral-100">
        {icon}
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-font12 text-neutral-500 flex flex-row items-center gap-1">
          {label}
        </p>
        {renderValue()}
        {subtitle && <p className="text-font10 text-neutral-500">{subtitle}</p>}
      </div>
    </div>
  );
}
